import React, { useRef,useEffect,useState } from "react";
import "./AvailableProperty.css";
import api from "../../Api.js"
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const properties = [
  {
    status: "Available",
    name: "Luxury Villa kalyani best place",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
];


const PropertySlider = () => {
  const sliderRef = useRef(null);
  const naviagte = useNavigate();

  const scroll = (direction) => {
    const { current } = sliderRef;
    const scrollAmount = 320;
    current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };


  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      const response = await api.get("developers-property")
      if(response.data.status === true){
          setProperties(response.data.data);
      }
    };
fetchProperties();
  
  }, []);

  return (
    <div className="slider-wrapper" id="projects">
            <motion.h2
        className="gallery-title"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Available <span>Properties</span>
      </motion.h2>
      {/* Desktop buttons only */}
      <button className="nav-btn left" onClick={() => scroll("left")}>
        ❮
      </button>

      <div className="slider-container" ref={sliderRef}>
        {properties.map((item, index) => (
          <div className="property-card" key={index} onClick={()=>naviagte(`/property-details/${item.id}`)}>
            <img src={`https://admin.houseofdhanushdhari.com/public/${item.property_image}`} alt={item.property_image} />

            <div className="card-body">
              <h3 className="status">Available</h3>
              <h4 className="name">{item.property_name}</h4>
              <p className="address">{item.location}</p>
              <p className="price">₹ {item.price}</p>
               {/* <h3 className="status">{item.status}</h3> */}

              <button className="book-btn">Book Now</button>
            </div>
          </div>
        ))}
      </div>

      <button className="nav-btn right" onClick={() => scroll("right")}>
        ❯
      </button>
    </div>
  );
};

export default PropertySlider;
